module.exports = __webpack_public_path__ + "img/47.f94f947b.png";